import React from 'react';
import { Page } from 'components';
import { Typography } from '@material-ui/core';
import { Card, CardContent, Link, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

const HelpPage = () => {
  const { t } = useTranslation();

  return (
    <Page title="Help">
      <Typography variant="h2">{t('help_page')}</Typography>
      <Card sx={{ marginTop: 5 }}>
        <CardContent>
          <Typography variant="h4">{t('getting_started')}</Typography>
          <Grid sx={{ paddingTop: 2 }}>
            <Link
              href="https://teralytic-dashboard-help-docs.s3.us-west-2.amazonaws.com/Getting_Started.pdf"
              title="Getting Started Documentation"
              variant="subtitle2"
              target="_blank"
            >
              {t('getting_started_documentation')}
            </Link>
          </Grid>
        </CardContent>
      </Card>
    </Page>
  );
};

export default HelpPage;
